import { TProductCoupon } from "@/models/products.model";
import axios from "@utils/axios-instance";

const getCoupons = async (): Promise<TProductCoupon[]> => {
  const response = await axios.get(`/coupon`);
  return response.data;
};

const saveCoupon = async (data: Omit<TProductCoupon, "created" | "updated">): Promise<TProductCoupon> => {
  const response = await axios.post(`/coupon`, data);
  return response.data;
};

const deleteCoupon = async (id: number): Promise<void> => {
  await axios.delete(`/coupon/${id}`);
};

const updateCoupon = async (id: number, data: Omit<TProductCoupon, "created" | "updated">): Promise<TProductCoupon> => {
  const response = await axios.patch(`/coupon/${id}`, data);
  return response.data;
};
export default {
  getCoupons,
  saveCoupon,
  updateCoupon,
  deleteCoupon,
};
